"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeedbackMobile_1 = require("./FeedbackMobile");
exports.default = FeedbackMobile_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/Feedback/FeedbackMobile/index.js
// module id = 557
// module chunks = 8